import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { getServiceImage } from '../../utils/serviceImages';
import './ServiceCard.css';

const ServiceCard = ({
  category,
  index = 0,
  onBookClick,
  Icon
}) => {
  const description = category.short_description || category.description || '';
  const serviceImage = getServiceImage(category);

  return (
    <motion.div
      className="service-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
    >
      {serviceImage ? (
        <div className="service-card-image">
          <img src={serviceImage} alt={category.name} />
        </div>
      ) : (
        <div className="service-card-image service-card-placeholder">
          <div className="service-placeholder-icon">
            {Icon && <Icon />}
          </div>
        </div>
      )}
      <div className="service-card-content">
        <h3>{category.name}</h3>
        {category.price_note && (
          <p className="service-card-price">{category.price_note}</p>
        )}
        <p className="service-card-description">{description}</p>
        <div className="service-card-actions">
          <Link to={`/services/${category.slug}`} className="service-learn-more">
            Learn More <FaArrowRight />
          </Link>
          {onBookClick && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={onBookClick}
            >
              Book Now
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
